<template>
  <div id="modalWrapper">
    <router-view />
  </div>
</template>
